/**
 * Maps react-hook-form field paths to the Task Editor material top tab route names.
 */

export const TASK_EDITOR_GRADING_RUBRIC_FEATURE_FLAG = 'lecturer-grading-rubric';

export type TaskFormTabsParamList = {
  Task: undefined;
  Resources: undefined;
  Evaluation: undefined;
  'Grading Rubric': undefined;
  MCQ: undefined;
  OralExam: undefined;
};

export type TaskFormTabRouteName = keyof TaskFormTabsParamList;

export function taskEditorFieldPathToTab(fieldPath: string): TaskFormTabRouteName {
  if (fieldPath.startsWith('evaluation.') || fieldPath === 'evaluation') {
    return 'Evaluation';
  }
  if (fieldPath.startsWith('rubric.') || fieldPath === 'rubric') {
    return 'Grading Rubric';
  }
  if (fieldPath.startsWith('mcqConfig.') || fieldPath === 'mcqConfig') {
    return 'MCQ';
  }
  if (fieldPath.startsWith('oralExamConfig.') || fieldPath === 'oralExamConfig') {
    return 'OralExam';
  }
  return 'Task';
}

export type TaskEditorTabResolveContext = {
  isActivity: boolean;
  isEssay: boolean;
  isMCQ: boolean;
  isOralExam: boolean;
  aiEnabled: boolean;
  gradingRubricEnabled: boolean;
};

/**
 * Picks a tab that exists for the current task type and feature flags.
 * Falls back to Task when the mapped tab is not mounted.
 *
 * MCQ and OralExam tabs are mounted whenever the task type matches; they
 * are no longer flag-gated on the read path (see TaskFormNavigator).
 */
export function resolveTaskEditorTabForField(
  fieldPath: string,
  ctx: TaskEditorTabResolveContext,
): TaskFormTabRouteName {
  const tab = taskEditorFieldPathToTab(fieldPath);
  if (tab === 'Evaluation' && ctx.isActivity) {
    return 'Task';
  }
  if (tab === 'Grading Rubric' && (!ctx.isEssay || !ctx.gradingRubricEnabled)) {
    return 'Task';
  }
  if (tab === 'MCQ' && !ctx.isMCQ) {
    return 'Task';
  }
  if (tab === 'OralExam' && !ctx.isOralExam) {
    return 'Task';
  }
  return tab;
}
